document.addEventListener("DOMContentLoaded", () => {
  const cards = document.querySelectorAll(".video-card");

  if (!cards.length) return;

  /**
   * Pause every video except the current one
   */
  function pauseOthers(currentVideo) {
  cards.forEach((card) => {
    const video = card.querySelector("video");
    const playBtn = card.querySelector(".video-card__play");
    const muteBtn = card.querySelector(".video-card__mute");
    const thumbnail = card.querySelector(".video-card__thumbnail");

    if (!video || video === currentVideo) return;

    video.pause();

    if (playBtn) {
      playBtn.classList.remove("is-hidden");
    }

    if (thumbnail) {
      thumbnail.classList.remove("is-hidden");
    }

    muteBtn?.classList.toggle("is-active", !video.muted);
  });
}

  cards.forEach((card) => {
    const video = card.querySelector("video");
    const playBtn = card.querySelector(".video-card__play");
    const muteBtn = card.querySelector(".video-card__mute");
    const thumbnail = card.querySelector(".video-card__thumbnail");

    if (!video) return;

    /**
     * Initial State
     */

    video.pause();
    video.muted = false;
    video.controls = false;
    video.playsInline = true;
    muteBtn?.classList.toggle("is-active", !video.muted);

    /**
     * Play Button
     */

    playBtn?.addEventListener("click", () => {
      pauseOthers(video);
  // video.muted = false;   // <-- Add this

      video.play();

      playBtn.classList.add("is-hidden");

      if (thumbnail) {
        thumbnail.classList.add("is-hidden");
      }
    });

    /**
     * Clicking Video
     */

    video.addEventListener("click", () => {
      if (video.paused) {
        pauseOthers(video);
  // video.muted = false;   // <-- Add this

        video.play();

        playBtn.classList.add("is-hidden");

        if (thumbnail) {
          thumbnail.classList.add("is-hidden");
        }
      } else {
        video.pause();

        playBtn.classList.remove("is-hidden");

        if (thumbnail) {
          thumbnail.classList.remove("is-hidden");
        }
      }
    });

    /**
     * Ended
     */

    video.addEventListener("ended", () => {
      playBtn.classList.remove("is-hidden");

      if (thumbnail) {
        thumbnail.classList.remove("is-hidden");
      }
    });

    /**
     * Pause
     */

    video.addEventListener("pause", () => {
      playBtn.classList.remove("is-hidden");

      if (thumbnail) {
        thumbnail.classList.remove("is-hidden");
      }
    });

    /**
     * Playing
     */

    video.addEventListener("play", () => {
      playBtn.classList.add("is-hidden");

      if (thumbnail) {
        thumbnail.classList.add("is-hidden");
      }
    });

    /**
     * Mute
     */

    muteBtn?.addEventListener("click", (e) => {
      e.stopPropagation();

      video.muted = !video.muted;

      muteBtn.classList.toggle("is-active", !video.muted);
    });
  });
});